import { Typography } from '@mui/material';
import ManageDriverTable from './ManageDriverTable';

const ManageDriver = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Delivery boy/Driver Management
      </Typography>
      <ManageDriverTable />
    </>
  );
};

export default ManageDriver;
